<template>
  <ul class="prop-pages">
      <li v-for="item in navData" :key="item.index" @click="handleGoUrl(item)">
          <span :style="{backgroundImage:'url(' + item.icon + ')'}" class="resertIcon"></span>
          <span>{{ $t(item.name) }}</span>
      </li>
      <li @click="loginOut">
          <span class="logOut resertIcon"></span>
          <span>{{$t('common.loginOut')}}</span>
      </li>
  </ul>


</template>

<script>
import {  commonApi } from "@/common/index";
import { navData } from '../../views/mine/index';
   export default {
       data(){
           return{
               navData
           }
       },
       methods:{
           handleGoUrl({ url }){
               this.$router.push({path:url})
           },
            loginOut() {
                commonApi.USER.loginOut().then((msg) => {
                    this.$emit('getCookie');
                    this.$notify({
                        title:this.$t('notify.success'),
                        message:this.$t('header.exitSuccessfully'),
                        type: "success"
                    });
                    this.$router.push({ path: "/" });
                }).catch((err) => {});
            },
       }
  }

</script>

<style lang="scss" scoped>
.prop-pages{
    background: linear-gradient(118.88deg, #474747 0%, #323631 100%);
    border-radius: 10px;
    position: absolute;
    right:0;
    z-index:99;
    top:40px;
    width: 260px;
    padding-bottom:20px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
    padding:5px;
    li{
        border-radius:10px;
        color:#fff;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        font-weight: normal;
        padding-left:15px;
        cursor: pointer;
        span{ display:inline-block;}
        .resertIcon{
          width:40px;
          height:35px;
          background-size: 100%;
          background-repeat: no-repeat;
          background-position-y:88%;
          vertical-align: middle;
        }
        .logOut{
            background-image:url('./img/my_nai_logout.png');
        }
        // &:nth-child(1){ margin-top:12px;}
        &:hover{
          .resertIcon{ background-position-y:0%; }
          font-weight: 550;
           background: rgba(255, 255, 255, 0.098);
        //   background-image: linear-gradient(90deg,#80fbb4 0%,#c3fd7c 100%);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/Header/drawBox.vue